import React from 'react';
import { ReactComponent as ProcessingSvg } from './ProcessingLoader.svg';
import styles from './Processing.module.css';

const Processing = ({ text }: { text: string }) => (
	<div data-testid="processing-component" className={styles.processingLoaderContainer}>
		<ProcessingSvg className={styles.processingSvg} />
		<span className={styles.processingText}>{text}</span>
	</div>
);

export default Processing;
